import { clsx } from 'clsx';
import {
  Typography,
  TypographyProps,
} from '@design-system/components/typography/typography';
import {
  MarkdownContent,
  mdToHTML,
} from '@design-system/components/markdownContent';
import { splitTextByChannelMention } from '../lib/channelMention';

type Props = Omit<TypographyProps, 'children' | 'dangerouslySetInnerHTML'> & {
  content: string;
  mentions?: string[];
};

export const MentionText = ({
  content,
  mentions,
  className,
  ...props
}: Props) => {
  const parts = splitTextByChannelMention(content, mentions);

  if (!parts.some((part) => part.isMention)) {
    return (
      <MarkdownContent content={content} className={className} {...props} />
    );
  }

  return (
    <Typography
      className={clsx(
        'whitespace-pre-wrap text-[#131313] [&_a]:text-blue-1 [&_a:hover]:text-blue-2',
        className,
      )}
      {...props}
    >
      {parts.map((part, index) =>
        part.isMention ? (
          <span key={index} data-mention="true" className="text-[#5F1ECC]">
            {part.text}
          </span>
        ) : (
          <span
            key={index}
            dangerouslySetInnerHTML={{ __html: mdToHTML(part.text) }}
          />
        ),
      )}
    </Typography>
  );
};
